export class PersonFieldParameter {
  activeDirectories: string[] | undefined;
  employeeTypes: string[] | undefined;
  forApproval: boolean | undefined;
}
